
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarElectronicBearingLineProposal as ObiRadarElectronicBearingLineProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-electronic-bearing-line-proposal.js';
 
 
 

 
 export const ObiRadarElectronicBearingLineProposal = createComponent({
   react: React,
   tagName: 'obi-radar-electronic-bearing-line-proposal',
   elementClass: ObiRadarElectronicBearingLineProposalElement,
   events: {
     
   }
  });
 
 